import {baseSupplementValidators} from '../supplementHelpers/baseSupplement.validators';

export const validators = {
  ...baseSupplementValidators
};
